const AUTH_KEY = "auth";

export { AUTH_KEY };
